import * as React from 'react';

import SignatureStatusLabel from 'af-root/scenes/Company/FieldReports/Shared/SignatureStatusLabel';

import type { TimeSheetInfoVM, TimeSheetEntryInfoVM, TimeSheetCertificationStatusVM } from 'ab-viewModels/workOrder/submitForReviewRecap';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { bemElement } from 'af-utils/bem.util';
import { useToggle } from 'af-utils/react.util';

import styles from './styles.module.scss';
import TimeSheet from './TimeSheet';
import CertificationStatusDisplay from '../../../../TimeSheets/TimeSheetRow/CertificationStatusDisplay';

interface OwnProps {
	timeSheet: TimeSheetInfoVM;
	timeSheetEntries: TimeSheetEntryInfoVM[];
	timezone: Nullable<string>;
	showWorkShift: boolean;
}

type Props = OwnProps;

const TimeSheetEmployee: React.FC<Props> = (props) => {
	const { timeSheet, timeSheetEntries, timezone, showWorkShift } = props;

	const { value: isExpanded, toggle: toggleExpanded } = useToggle(false);

	const timeZoneOffset = React.useMemo(() => timezone ? TimeUtils.getOffset(timezone) : 0, [timezone]);

	const itemClassName = bemElement('report-submit-modal__section', 'list-item', {
		expanded: isExpanded,
	});

	const sortedTimeSheetShifts = React.useMemo(() => {
		return sortShifts(timeSheet.workShifts);
	}, [timeSheet.workShifts]);

	const showLatestShift = showWorkShift && !isExpanded && sortedTimeSheetShifts[0];

	return (
		<div className={itemClassName}>
			<div className="modal-time-sheet-employee">

				<div>
					{
						timeSheet.isTemporaryEmployee &&
						<span className="icon-temp_labor" />
					}
					{timeSheet.userName}
				</div>
				<div className="modal-time-sheet-employee__status">
					{showLatestShift &&
						<CertificationStatusDisplay
							key={sortedTimeSheetShifts[0].timeSheetId}
							timeZoneOffset={timeZoneOffset}
							tooltipPlacement="left"
							workShift={sortedTimeSheetShifts[0]}
						/>
					}
					<SignatureStatusLabel status={timeSheet.signatureStatus} />
					<span className={`modal-time-sheet-employee__expander ${isExpanded ? 'icon-up' : 'icon-down'}`} onClick={toggleExpanded} />
				</div>
			</div>
			{isExpanded &&
				<>
					{showWorkShift &&
						<>
							<div className={styles.certificationStatusesContainerTitle}>Certification Statuses: </div>
							<div className={styles.certificationStatusesContainer}>
							{sortedTimeSheetShifts.map((_tss, _index) =>
								<CertificationStatusDisplay
									key={_index}
									timeZoneOffset={timeZoneOffset}
									tooltipPlacement="left"
									workShift={_tss}
								/>)
							}
							</div>
						</>
					}
					<TimeSheet
						timeSheet={timeSheet}
						timeSheetEntries={timeSheetEntries}
						timezone={timezone}
					/>
				</>
			}
		</div>
	);

	function sortShifts(timeSheetShifts: TimeSheetCertificationStatusVM[]) {
		return [...timeSheetShifts].sort((a, b) => {
			if (a.endTime && b.endTime && new Date(b.endTime).getTime() !== new Date(a.endTime).getTime()) {
				return new Date(b.endTime).getTime() - new Date(a.endTime).getTime();
			}
			if (a.startTime && b.startTime) {
				return new Date(b.startTime).getTime() - new Date(a.startTime).getTime();
			}
			return 0;
		});
	}
};

export default React.memo(TimeSheetEmployee);
